module.exports = __webpack_public_path__ + "assets/img/left-title-open-2399c753.png";